import { Outlet, Navigate } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import MobileNav from "@/components/MobileNav";
import NotificationBell from "@/components/NotificationBell";
import { useAuth } from "@/context/AuthContext";

export default function AppLayout() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="min-h-screen flex bg-white text-[var(--app-text)]">
      <Sidebar />
      <main className="flex-1 min-w-0 overflow-x-hidden flex flex-col">
        <MobileNav />
        <div className="h-14 shrink-0 border-b border-[var(--app-line)] bg-white/80 backdrop-blur flex items-center justify-end px-4 sticky top-0 z-30">
          <NotificationBell />
        </div>
        <div className="flex-1">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
